import React, { useState } from 'react';
import { createContact } from '../services/authService';
import Swal from 'sweetalert2'; // Import SweetAlert

function ContactSection() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        mobile: '',
        linkedIn: '',
        message: ''
    });

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true); // Set loading to true when submitting

        try {
            const result = await createContact(formData);
            //console.log('Contact created successfully:', result);
            // Show success alert
            Swal.fire({
                title: 'Success!',
                text: 'Your message has been sent successfully!',
                icon: 'success',
                confirmButtonText: 'OK'
            });

            // Clear form after successful submission
            setFormData({
                name: '',
                email: '',
                mobile: '',
                linkedIn: '',
                message: ''
            });
        } catch (error) {
            // Show error alert
            Swal.fire({
                title: 'Error!',
                text: error.message,
                icon: 'error',
                confirmButtonText: 'OK'
            });
        } finally {
            setLoading(false); // Reset loading state
        }
    };

    return (
        <div className=" p-4 lg:px-20 mx-auto">
            <img
                src="https://images.pexels.com/photos/7698715/pexels-photo-7698715.jpeg"
                alt="A group of people working together"
                className="w-full h-64 md:h-80 lg:h-96 object-cover rounded-t-lg"
            />
            <div data-aos="fade-up" className="flex flex-col md:flex-row justify-center items-start space-y-8 md:space-y-0 mt-6 gap-6">
                <div className="bg-white shadow-lg p-6 rounded-lg w-full md:w-1/3">
                    <h2 style={{ fontFamily: "Helvetica" }} className="text-xl font-bold mb-4">REACH OUT TO US</h2>
                    <div className="flex items-center mb-4">
                        <i className="fas fa-phone-alt text-blue-500 mr-4"></i>
                        <div>
                            <p className="font-semibold">Phone</p>
                            <p>+91-99804 73772</p>
                        </div>
                    </div>
                    <div className="flex items-center mb-4">
                        <i className="fas fa-envelope text-blue-500 mr-4"></i>
                        <div>
                            <p className="font-semibold">Email</p>
                            <p>support@coachkshitij.com</p>
                        </div>
                    </div>
                    <a rel="noreferrer"
                        href="https://calendly.com/epcoachkshitij/" target='_blank'
                        className="inline-block bg-blue-500 text-white py-2 px-4 rounded-full text-center mt-4 hover:bg-blue-600 transition duration-300"
                    >
                        MAKE APPOINTMENT
                    </a>
                </div>

                <div data-aos="fade-up" className="bg-white shadow-lg p-6 rounded-lg w-full md:w-2/3">
                    <h2 style={{ fontFamily: "Helvetica" }} className="text-xl font-bold mb-4">CONNECT WITH US</h2>
                    <p className="text-sm text-gray-600 mb-4">Your email address will not be published. Required fields are marked.</p>
                    <form className="space-y-4" onSubmit={handleSubmit}>
                        <input
                            type="text"
                            name="name"
                            placeholder="Your Name *"
                            className="w-full p-3 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300"
                            value={formData.name} // Control the input value
                            onChange={handleChange}
                            required
                        />
                        <input
                            type="email"
                            name="email"
                            placeholder="Your Email *"
                            className="w-full p-3 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300"
                            value={formData.email} // Control the input value
                            onChange={handleChange}
                            required
                        />
                        <input
                            maxLength={10}
                            type="text"
                            name="mobile"
                            placeholder="Your Mobile *"
                            className="w-full p-3 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300"
                            value={formData.mobile} // Control the input value
                            onChange={handleChange}
                            required
                        />
                        <input
                            type="text"
                            name="linkedIn"
                            placeholder="Enter LinkedIn Profile URL"
                            className="w-full p-3 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300"
                            value={formData.linkedIn} // Control the input value
                            onChange={handleChange}
                        />
                        <textarea
                            name="message"
                            placeholder="Your Message"
                            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 h-32 transition duration-300"
                            value={formData.message} // Control the input value
                            onChange={handleChange}
                            required
                        ></textarea>
                        <button
                            type="submit"
                            className="inline-block bg-blue-500 text-white py-2 px-4 rounded-full text-center transition duration-300 hover:bg-blue-600"
                            disabled={loading} // Disable button when loading
                        >
                            {loading ? 'Sending...' : 'SEND MESSAGE'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default ContactSection;
